// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelEnableLink-Link_cls1__6aHXm","cls2":"PaymentChannelEnableLink-Link_cls2__0lipH PaymentChannelEnableLink-Link_cls1__6aHXm"};